import React, { useEffect } from "react";
import { Modal, Typography, Form, Input } from "antd";
import { AiOutlineClose, AiOutlineArrowRight } from "react-icons/ai";

import PrimaryButton from "../Forms/PrimaryButton";
import { useGlobalModal } from "../../context/SuccessModalProvider";
import { formRules } from "../../constant";

const { Title } = Typography;

export default function CancelOrderModal({
  open,
  onClose,
  handleSubmit,
  cancelRemark,
  setCancelRemark,
  title = "Do you want to cancel this order?",
  loading,
  btntext = "Cancel Order",
  orderData,
}) {
  const { showPopup } = useGlobalModal();

  const orderDataStr = JSON.stringify(orderData);
  useEffect(() => {
    setCancelRemark("");
  }, [orderDataStr]);

  return (
    <Modal
      className="form-css custom-modal cancel-modal"
      open={open}
      footer={null}
      onCancel={onClose}
      centered
      width={475}
    >
      {/* Header */}
      <div className="flex justify-between items-center">
        <Title level={2} className="text-lg font-semibold text-black m-0 font-abhaya !mb-2">
          {title}
        </Title>
      </div>

      {/* Form */}
      <Form
        layout="vertical"
        onFinish={() => {
          if (!cancelRemark?.trim()) {
            return showPopup({
              title: null,
              content: <span className="custom-modal-title">Please add a remark.</span>,
              onOk: () => console.log("Confirmed!"),
              className: "custom-success-modal",
            });
          }
          handleSubmit();
        }}
      >
        <Form.Item label="Remark" className="font-semibold" rules={formRules.required}>
          <Input.TextArea
            value={cancelRemark}
            onChange={(e) => setCancelRemark(e.target.value)}
            rows={4}
            placeholder="Add a remark here..."
            className="rounded-lg"
          />
        </Form.Item>
        <div className="w-full mt-4 flex justify-center">
          <PrimaryButton text={btntext} type={"submit"} loading={loading} className="me-[30px]" />
        </div>
      </Form>

      {/* Footer */}
    </Modal>
  );
}
